/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pricing_buttons_selectplan1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택하기`)
};

const en_pricing_buttons_selectplan1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const ja_pricing_buttons_selectplan1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pricing_buttons_selectplan1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pricing_buttons_selectplan1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pricing_buttons_selectplan1", locale)
	if (locale === "ko") return ko_pricing_buttons_selectplan1(inputs)
	if (locale === "en") return en_pricing_buttons_selectplan1(inputs)
	return ja_pricing_buttons_selectplan1(inputs)
};
export { pricing_buttons_selectplan1 as "pricing_buttons_selectPlan" }